// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1kpzz","dragIcon":"Choice_dragIcon__KRaWm","left":"Choice_left__2FBMN","input":"Choice_input__1hwFu"};